import { Font } from "@react-pdf/renderer";

// The look shared by PLOT's exported PDFs (the delivery manifest and the jobsite logistics sheet).
Font.register({
    family: "Open Sans",
    fonts: [
        { src: "/fonts/OpenSans-Regular.ttf" },
        { src: "/fonts/OpenSans-SemiBold.ttf", fontWeight: 600 },
        { src: "/fonts/OpenSans-Bold.ttf", fontWeight: 900 },
        { src: "/fonts/OpenSans-Italic.ttf", fontStyle: "italic" },
    ],
});
Font.registerHyphenationCallback((word) => [word]);

export const PDF_FONT = "Open Sans";
export const PDF_ORANGE = "#ff9e00";
export const PDF_ORANGE_TINT = "#ffefd1";
export const PDF_INK = "#111827";
export const PDF_MUTED = "#6b7280";
export const PDF_RULE = "#e5e7eb";
